// removed by extract-text-webpack-plugin
module.exports = {"la-pacman":"_2dxn8Dvn","la-dark":"_1_cUaHlh","pacman-rotate-half-up":"_2vTE5bmF","pacman-rotate-half-down":"_1Ga1iO5_","pacman-balls":"UP1Nh9HD","la-sm":"_3M-gJMIS","la-2x":"_3eEwL4Iq","la-3x":"_1Jpr1x1l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/Loader.css
// module id = 96
// module chunks = 0